'use client';

import { Wrapper } from '@googlemaps/react-wrapper';
import { GOOGLE_MAPS_KEY } from '@nettbureau/featured-core';
import { MapContainer } from './MapContainer';

interface GoogleMapProps {
  markerDefinitions: MarkerDefinition[];
  maxZoom: number;
}

export interface MarkerDefinition {
  id: number;
  name: string;
  address: string;
  postcode: string | null;
  postarea: string | null;
  lat: number;
  lng: number;
  url: string | null;
  color: 'red' | 'gray';
  infoWindow?: google.maps.InfoWindow;
  marker?: google.maps.marker.AdvancedMarkerElement;
}

export function GoogleMap({ maxZoom, markerDefinitions }: GoogleMapProps) {
  if (markerDefinitions.length === 0) {
    return null;
  }

  const combinedEntities = markerDefinitions
    .map(({ lat, lng }) => ({ lat, lng }))
    .reduce((a, b) => {
      return {
        lat: a.lat + b.lat,
        lng: a.lng + b.lng,
      };
    });

  const center = {
    lat: combinedEntities.lat / markerDefinitions.length,
    lng: combinedEntities.lng / markerDefinitions.length,
  };

  return (
    <div>
      <Wrapper
        libraries={['marker', 'core', 'maps']}
        apiKey={GOOGLE_MAPS_KEY ?? ''}
      >
        <MapContainer
          center={center}
          maxZoom={maxZoom}
          markerDefinitions={markerDefinitions}
        />
      </Wrapper>
    </div>
  );
}

export type { MarkerDefinition as Marker };
